import React from 'react'
import {Svg} from '@modifi/ui'

export default props => (
  <Svg width="221" height="221" viewBox="0 0 221 221" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#EDEDED"
        d="M220.461062,120.795 L0.600938296,120.795 C0.293245303,117.436262 0.136,114.033996 0.136,110.595 C0.136,49.626 49.56,0.2 110.53,0.2 C171.5,0.2 220.926,49.625 220.926,110.595 C220.926,114.033996 220.768755,117.436262 220.461062,120.795 Z"
      />
      <path
        transform="translate(0.000000, 116.000000)"
        fill="#D5EAEE"
        d="M0.298422973,0.635 L220.763577,0.635 C217.627618,58.796022 169.474448,104.99 110.531,104.99 C51.5875519,104.99 3.43438153,58.796022 0.298422973,0.635 Z"
      />
      <path fill="#E8E8E8" d="M38 144.373h124V62H38z" />
      <path
        fill="#1251A0"
        fillRule="nonzero"
        d="M79 66.077V49h43v17.077H79zm39.497-3.536V52.536H82.503V62.54h35.994z"
      />
      <path fill="#2563A7" d="M153.84 103.186H46.16L38 62h124z" />
      <path fill="#4AA6DD" d="M62 111.077h17V94H62z" />
      <path fill="#2B99DA" d="M122 113.514h17V96.436h-17z" />
      <g>
        <path fill="#C0DAE5" d="M38 150.736h124.579v-7.077H38zM112 173h65v-3h-65z" />
        <path fill="#E8E8E8" d="M112.889 168.912H176V91.12h-63.111z" />
        <path
          fill="#2B99DA"
          fillRule="nonzero"
          d="M112 169.806V89.332h64v80.474h-64zm1.64-1.66h60.72V90.992h-60.72v77.154z"
        />
        <path
          fill="#2B99DA"
          d="M129.691 100.956l-5.606 5.97-2.22-2.366-.976 1.04 3.196 3.403 6.582-7.008z"
        />
        <g fill="#D8D8D8">
          <path d="M136.285 103.974h30.405v-2.953h-30.405zM136.285 108.729h30.405v-2.953h-30.405zM121.082 119.838h45.608v-2.953h-45.608zM121.082 124.593h45.608v-2.953h-45.608zM121.286 129.194h45.608v-2.953h-45.608zM121.286 133.949h45.608v-2.953h-45.608zM121.286 138.704h45.608v-2.953h-45.608zM121.286 143.458h45.608v-2.953h-45.608zM121.491 148.059h45.608v-2.953H121.49zM121.491 152.814h45.608v-2.953H121.49z" />
        </g>
      </g>
    </g>
  </Svg>
)
